var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.13 50.51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.76 50.51v-11.87h1.9l-8.88-26.77h-3.78v-11.87h20.7v11.87h-1.57l5.01 15.1 5.05-15.1h-1.45v-11.87h21.39v11.87h-4.57l-8.89 26.77h2.28v11.87z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.28 48.99v-8.83h2.56l-9.93-29.81h-3.39v-8.83h17.66v8.83h-2.22l7.18 21.62 7.22-21.62h-2.1v-8.83h18.35v8.83h-4.18l-9.93 29.81h2.93v8.83z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.97 8.76v-5.7h14.61v5.7h-2.78l9.33 28.15 9.41-28.15h-2.71v-5.7h15.1v5.7h-3.63l-10.97 32.92h3.56v5.7h-21.09v-5.7h3.21l-10.98-32.92z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.86c4303ee972b773cb1fc6dbcbeda8d8.svg";
export { ForwardRef as ReactComponent };